const affiliates = [
  {
    text: 'footer.ledger',
    price: '59.00',
    description:
      'A light, yet solid multicurrency hardware wallet for cryptocurrencies. It is easy to carry everywhere thanks to its USB format.',
    href: 'https://www.ledger.com?r=fa4b',
    currency: '$',
    logo: 'ledger'
  },
  {
    text: 'footer.ethCard',
    price: '',
    description: '',
    href:
      'https://ether.cards/?utm_source=mew&utm_medium=cpm&utm_campaign=site',
    currency: '',
    logo: ''
  },
  {
    text: 'footer.bity',
    price: '',
    description: '',
    href: 'https://bity.com/af/jshkb37v',
    currency: '',
    logo: ''
  },
  {
    text: 'footer.billfodl',
    price: '',
    description: '',
    href:
      'https://billfodl.com/?afmc=2j&utm_campaign=2j&utm_source=leaddyno&utm_medium=affiliate',
    currency: '',
    logo: ''
  },
  {
    text: 'footer.finney',
    price: '999.00',
    description: 'Uncompromised Security In a Blockchain Smartphone',
    href:
      'http://shop.sirinlabs.com?rfsn=2397639.54fdf&utm_source=refersion&utm_medium=affiliate&utm_campaign=2397639.54fdf',
    currency: '$',
    logo: 'finney'
  },
  {
    text: 'footer.bitbox',
    price: '59.00',
    description:
      'Our aim is to equip you for independence, with ease, in the digital world.',
    href: 'https://digitalbitbox.com/?ref=mew',
    currency: '€',
    logo: 'bitbox'
  },
  {
    text: 'footer.trezor',
    price: '83.49',
    description:
      'The most trusted hardware wallet in the world. Get yours today!',
    href: 'https://trezor.io/?offer_id=12&aff_id=2029',
    currency: '€',
    logo: 'trezor'
  },
  {
    text: 'footer.secalot',
    price: '50.00',
    description:
      'Your all-in-one digital security companion. it is a small USB dongle that packs a wide range of features.',
    href: 'https://www.secalot.com/',
    currency: '$',
    logo: 'secalot'
  },
  {
    text: 'footer.keepkey',
    price: '79.00',
    description:
      'Protect your cryptocurrencies, store your private keys offline, and safeguard your assets from hackers.',
    href: 'http://keepkey.go2cloud.org/aff_c?offer_id=1&aff_id=5561',
    currency: '$',
    logo: 'keepkey'
  }
];

export default affiliates;
